<template>
  <component :is="element" class="flex flex-col gap-2" :class="$attrs.class">
    <p :class="['flex items-center gap-2 text-lg leading-none', getColor]">
      <span v-if="icon" :class="icon" class="text-md" aria-hidden="true" />
      <span class="font-medium">{{ label }}</span>
    </p>
    <p :class="['w-full px-3 min-w-40 py-2 rounded-lg cursor-default focus:outline-none truncate', getColor, getBgColor]" :title="value">
      {{ value }}
    </p>
  </component>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: 'blue'
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    element: {
      type: String,
      default: 'div'
    }
  },
  computed: {
      getColor() {
          if(this.$attrs.disabled) return 'bg-bhav-cool-gray-50';
          switch(this.color) {
              case 'red' :
                  return 'text-bhav-red-500'
              case 'green' :
                  return 'text-bhav-green-600'
              case 'blue' :
              default :
                  return 'text-bhav-blue-500'
          }
      },
      getBgColor() {
          if(this.$attrs.disabled) return 'bg-bhav-cool-gray-50';
          switch(this.bgColor) {
              case 'gray' :
                  return 'bg-bhav-cool-gray-50'
              case 'red' :
                  return 'bg-bhav-red-100'
              case 'green' :
                  return 'bg-bhav-green-100'
              case 'white' :
              default :
                  return 'bg-white'
          }
      },
  }
}
</script>
